import { useState } from 'react';

// Keeps showing the last non-empty value, e.g. a dialog title while its parent
// clears the subject before the close animation ends.
export function useLastNonEmpty(value: string): string {
  const [last, setLast] = useState(value);
  if (value && value !== last) setLast(value);
  return value || last;
}
